module.exports = "https://chowbus-web-static.chowbus.com/_next/static/images/drivers-d52218b510de7f7011762e5e270c803d.jpg";